import React from 'react';
import './index.css';
import {useTranslation} from 'react-i18next';
import { HOTLINE, FAX, EMAIL, MOBILE, WHATSAPP_URL, LANG_PREFIX } from '../../config/siteConfig';

const PhoneIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.4a2 2 0 0 1 1.99-2.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7a2 2 0 0 1 1.72 2.02z"/>
    </svg>
);

const MailIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect width="20" height="16" x="2" y="4" rx="2"/>
        <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
    </svg>
);

const WhatsAppIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
    </svg>
);

const FaxIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"/>
        <path d="M8 10h8M8 14h5"/>
    </svg>
);

function PageFooter() {
    const {t, i18n} = useTranslation();
    return (
        <footer className="page-footer">
            <div className="page-container">
                {/* Logo & Contact */}
                <div className="footer-brand">
                    <img
                        className="footer-logo"
                        src="/files/images/footerLogo.png"
                        alt="footer-logo"
                    />
                    <ul className="footer-contact-list">
                        <li className="footer-contact-item">
                            <span className="footer-contact-icon"><PhoneIcon /></span>
                            <a href={`tel:${HOTLINE.replace(/-/g, '')}`}>{t('phone')}：{HOTLINE}</a>
                        </li>
                        <li className="footer-contact-item">
                            <span className="footer-contact-icon"><FaxIcon /></span>
                            <span>{t('fax')}：{FAX}</span>
                        </li>
                        <li className="footer-contact-item">
                            <span className="footer-contact-icon"><MailIcon /></span>
                            <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
                        </li>
                        <li className="footer-contact-item">
                            <span className="footer-contact-icon"><WhatsAppIcon /></span>
                            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">{MOBILE}</a>
                        </li>
                    </ul>
                </div>

                {/* Company Info */}
                <div className="footer-company">
                    <div className="footer-company-name">{t('company_name')}</div>
                    <div className="footer-company-name-en">XIAOMAI AUTOMATION TECHNOLOGY</div>
                    <div className="footer-divider" />
                    <div className="footer-company-address">{t('dongguan_factory_address_detail')}</div>
                    <div className="footer-promo">
                        <a className="footer-promo-link" href={`${LANG_PREFIX[i18n.language] || ''}/autumn-2026/`}>
                            <span className="footer-promo-badge">NEW</span>
                            {t('autumn_footer_link')}
                        </a>
                    </div>
                    <div className="footer-copyright">
                        © {new Date().getFullYear()} {t('banquan')}
                    </div>
                    <div className="footer-beian">
                        <a
                            href="https://beian.miit.gov.cn/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="footer-beian-link"
                        >
                            <svg className="footer-beian-icon" viewBox="0 0 24 24" aria-hidden="true">
                                <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
                            </svg>
                            <span>{t('beian')}</span>
                        </a>
                    </div>
                </div>

                {/* QR Code */}
                <div className="footer-qr">
                    <div className="footer-qr-title">WhatsApp</div>
                    <div className="footer-qr-wrap">
                        <img
                            className="footer-qr-img"
                            src="/files/images/whatsapp_cut.png"
                            alt="WhatsApp QR"
                        />
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default PageFooter;
